import { useTranslation } from "react-i18next";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { poolName } from "../../../../enviroments";
import { useAppSelector, useAppDispatch } from "../../../../states/hooks";
import { actions, selectIsDarkMode } from "../../../../states/appState";
import { Links } from "../links";
import { NavigationMenu } from "./components/NavigationMenu";
import { ToggleLanguageBtn } from "../components/ToggleLanguageBtn";
import { ToggleThemeBtn } from "../components/ToggleThemeBtn";
import { WalletConnectionBtn } from "./components/WalletConnectionBtn";
import { openExternalUrl } from "../../../utils/functions/stringMethods";

import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { openAppPromoDialog } from "../components/AppPromoDialog";
import styles from "./header.module.css";

export const Header = () => {
    const { t } = useTranslation();
    const { setIsOpenSidebar } = actions;
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const isDarkMode = useAppSelector(selectIsDarkMode);
    const imgLogo = "/logo.png";

    const shownContentDesktop = {
        width: "auto",
        display: { xs: "none", xl: "flex" },
    };

    const shownContentMobile = {
        width: "auto",
        display: { xs: "flex", xl: "none" },
    };

    const openSideDrawer = () => dispatch(setIsOpenSidebar(true));

    return (
        <AppBar
            position="sticky"
            className={(isDarkMode ? styles.darkHeader : styles.lightHeader) + " smReactHeader"}
            sx={{
                top: 0,
                transition: "all 220ms ease",
                zIndex: 100,
            }}
        >
            <Toolbar
                className={styles.toolbar + " smReactToolbar"}
                sx={{
                    flexGrow: 1,
                    width: "100%",
                    maxWidth: "1280px",
                    mx: "auto",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <Grid
                    item
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        minWidth: 0,
                    }}
                >
                    <Grid
                        container
                        item
                        className="smBrandBlock"
                        sx={{
                            width: "auto",
                            pr: { xs: 0, lg: 3 },
                            mr: { xs: 0, lg: 2 },
                            borderRight: { xs: 0, xl: 1 },
                            borderColor: { xs: "transparent", xl: "divider" },
                            minWidth: 0,
                        }}
                    >
                        <Link
                            to="/"
                            className={styles.linkContainer}
                            title="SignaMining Pool Startseite"
                        >
                            <img src={imgLogo} alt="SignaMining.de Logo" />
                            <Typography className="smBrandText" variant="h6">
                                {poolName}
                            </Typography>
                        </Link>
                    </Grid>

                    <Grid
                        container
                        item
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        className="smDesktopNav"
                        sx={shownContentDesktop}
                    >
                        {Links.map((link) => {
                            const visitPage = () => {
                                if (link.newWindow) {
                                    return openExternalUrl(link.url);
                                }
                                navigate(link.url);
                            };

                            const isActiveLink = location.pathname === link.url;

                            return (
                                <Grid item key={link.url}>
                                    <Button
                                        className={"smNavButton" + (isActiveLink ? " smNavButtonActive" : "")}
                                        onClick={visitPage}
                                        color="inherit"
                                        sx={{
                                            textTransform: "none",
                                            px: 2,
                                            fontSize: 15,
                                            border: 1,
                                            borderColor: "transparent",
                                        }}
                                    >
                                        {t(link.label)}
                                    </Button>
                                </Grid>
                            );
                        })}

                        <NavigationMenu />
                    </Grid>
                </Grid>

                <Grid item className="smHeaderRight">
                    <Grid
                        container
                        item
                        direction="row"
                        alignItems="center"
                        columnSpacing={1}
                        className="smDesktopControls"
                        sx={shownContentDesktop}
                    >
                        <Grid item>
                            <Stack
                                className="smHeaderIcons"
                                direction="row"
                                alignItems="center"
                                spacing={1}
                            >
                                <ToggleLanguageBtn />
                                <ToggleThemeBtn />
                                <WalletConnectionBtn />
                            </Stack>
                        </Grid>


                        <Grid item>
                            <Button
                                className="smAppsButton"
                                onClick={openAppPromoDialog}
                                startIcon={<PhoneIphoneIcon />}
                                sx={{
                                    textTransform: "none",
                                    px: 2.4,
                                    py: 1.05,
                                    borderRadius: 999,
                                }}
                            >
                                Apps
                            </Button>
                        </Grid>

                        <Grid item>
                            <Link to="/start-mining">
                                <Button
                                    className="smMiningButton"
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                        textTransform: "none",
                                        px: 3.5,
                                        py: 1.15,
                                        borderColor: "divider",
                                        borderRadius: 999,
                                    }}
                                >
                                    {t("startMining")}
                                </Button>
                            </Link>
                        </Grid>
                    </Grid>

                    <Grid
                        item
                        sx={{
                            ...shownContentMobile,
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        <IconButton
                            className="smMobileMenuButton"
                            onClick={openSideDrawer}
                            edge="start"
                            aria-label="Menü öffnen"
                            sx={{ border: 1, borderColor: "divider", my: 1 }}
                        >
                            <MenuIcon fontSize="large" />
                        </IconButton>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    );
};
